import { convertServerResponsivePropertyToClientResponsiveProperty } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/Styling/responsiveValues";
import { useResponsiveValue } from "@faire/web--source/ui/hooks/useResponsiveValue";
import { IGridComponent } from "@faire/web-api--source/indigofair/data/IGridComponent";

export const useCurrentTruncationBehaviour = (
  truncationBehaviour: IGridComponent.ITruncationBehaviour,
  responsiveTruncationBehaviour: IGridComponent.IResponsiveTruncationBehaviour = IGridComponent.IResponsiveTruncationBehaviour.build()
) => {
  const truncationBehaviourNew =
    convertServerResponsivePropertyToClientResponsiveProperty(
      truncationBehaviour,
      (truncationBehaviour) => truncationBehaviour,
      responsiveTruncationBehaviour
    );

  const currentTruncationBehaviour = useResponsiveValue(truncationBehaviourNew);

  // priority of truncation behaviour is none > clip > expand
  const hasNoTruncation =
    !!currentTruncationBehaviour.none ||
    !(currentTruncationBehaviour.expand || currentTruncationBehaviour.clip);

  const clipTruncation =
    !hasNoTruncation && !!currentTruncationBehaviour.clip?.max_rows
      ? currentTruncationBehaviour.clip
      : undefined;

  const expandTruncation =
    !hasNoTruncation &&
    !clipTruncation &&
    !!currentTruncationBehaviour.expand?.collapsed_max_rows
      ? currentTruncationBehaviour.expand
      : undefined;

  return {
    noTruncation: hasNoTruncation,
    clipTrunctation: clipTruncation,
    expandTruncation: expandTruncation,
  };
};
